import amaLog from "../helpers/log";

type ArrayString = string[] | string

let mergedVerticalParams: ArrayString = [];

const getMergedVerticals = (configVerticals: IVerticals | undefined = undefined) : ArrayString => {
    
    if(mergedVerticalParams.length > 0) return mergedVerticalParams;

    let msVerticals: any = [];

    //@ts-ignore
    if (configVerticals && configVerticals.length > 0) {
        let path = window.location.pathname.split('/');
        let slug = '';
        let match;
        if (!path.every( p => p === '')) {
            // Remove empty strings from path array if it is not startpage
            path = path.filter(p => p !== '');
        }

        if (Array.isArray(path)) {

        // go through all slug parts and look for verticals
        path.map((slugPart) => {
            // Create slug to search for and clean start/end from "/"
            slug = slug + '/' + slugPart;
            slug = slug.replace(/(^\/|\/$)/g, '');
            
            // Find vertical match by domain and slug
            //@ts-ignore
            match = configVerticals.find((verticals) => {
                const siteSlug = verticals.slug.replace(/(^\/|\/$)/g, '');
                return verticals.domain === window.location.hostname.replace(/(www-staging.|www.|dev.|stage.)/, '') && siteSlug === slug;
            });

            if (match && match.verticals) {
                const filteredVerticals = match.verticals.map( (str: string) => str.toLowerCase().startsWith('noje_') ? 'noje' : str);
                msVerticals = [...msVerticals, ...filteredVerticals];
            }
        });
        }
    }

//////////////////////////
///////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////////////
///////////////////////////////////
///////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////
/////////////////////////////////////////////////////
/////////////
    return mergedVerticalParams;
}

export const getGamVerticals = (configVerticals?: IVerticals) => {

    const mergedVerticals = getMergedVerticals(configVerticals);

    if (mergedVerticals && mergedVerticals.length > 0) {
        return mergedVerticals.length == 1 ? mergedVerticals[0] : mergedVerticals;
    }    
}

export const getDmVerticals = (configVerticals?: IVerticals) : Array<string> => {

    const mergedVerticals: ArrayString = getMergedVerticals(configVerticals) || [];

    const verticals: Array<string> = Array.isArray(mergedVerticals) ? mergedVerticals : [mergedVerticals];

    const dmVerticals = verticals.map((vertical: string) => {
      return vertical
        .replace(/å/g, 'a')
        .replace(/Å/g, 'a')
        .replace(/ä/g, 'a')
        .replace(/Ä/g, 'A')
        .replace(/ö/g, 'o')
        .replace(/Ö/g, 'O');
    });
    return dmVerticals;
}
